/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { postData, getData, putData, deleteData } from "utils/Gateway";

import { ecosystemSlug } from "Config/Config";

import HealthCenterCommonHeader from "../../HealthCenterCommonHeader/HealthCenterCommonHeader";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import CompanyScheduleHeader from "../Header/CompanyScheduleHeader";
import AvilibilityOptions from "data/Prod/AvailibilityDaysOptions.json";
import SaveTimeModal from "../Modal/SaveTimeModal";

const HealthCenterScheduleBody = () => {
  const { t } = useTranslation();
  const params = useParams();
  const history = useHistory();
  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [companyData, setCompanyData] = useState({});
  const [isCompanyModerator, setIsCompanyModerator] = useState(false);
  const [memberStatus, setMemberStatus] = useState({});

  const [avalibilityDays, setAvalibilityDays] = useState([]);

  const [selectedDayId, setselectedDayId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [isDataReady, setIsDataReady] = useState(false);

  // Fetch company data
  const getCompanyDetails = async () => {
    setIsLoading(true);
    try {
      const requestUrl = `${url.API_BASE_URL}${url.API_GET_COMPANY_DETAILS}/${params.id}?token=${token}`;
      const response = await getData(requestUrl);
      if (response.status) {
        setCompanyData(response.data);
        // Check if user is moderator
        if (
          response.data.moderator &&
          response.data.moderator._id === userInfo._id
        ) {
          setIsCompanyModerator(true);
        }
        setMemberStatus(response.data.memberstatus || {});
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  //create new availibility week
  const createWeekAvailibilityHandler = async () => {
    const promises = AvilibilityOptions.map(async (avilibilityday) => {
      try {
        const availibilityData = {
          dayname: avilibilityday.dayname,
          slug: avilibilityday.slug,
          weekdayorder: avilibilityday.weekdayorder,
          companyid: params.id,
          timeavailibilityids: [],
          tags: [],
        };

        const requestUrl =
          url.API_BASE_URL +
          url.API_ADD_NEW_SCHEDULE_AVAILIBILITY +
          `?token=${token}`;

        const response = await postData(requestUrl, availibilityData);
        return response.status ? response.data : null;
      } catch (error) {
        console.error(`Error for ${avilibilityday.dayname}:`, error.message);
        return null; // Return null for failed requests
      }
    });

    try {
      const responses = await Promise.all(promises);
      const validResponses = responses.filter((res) => res !== null);
      const sortedResponse = validResponses.sort(
        (a, b) => a.weekdayorder - b.weekdayorder
      );
      setAvalibilityDays(sortedResponse);

      // Optional: Show alert if some requests failed
      if (validResponses.length < AvilibilityOptions.length) {
        setAlertMessage("Some availability settings could not be created.");
        setMessageType("warning");
        setShowAlert(true);
      }
    } catch (error) {
      console.error("Unexpected error in batch creation:", error.message);
      setAlertMessage("Failed to create availability settings.");
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //get all availibility settings
  const getAllWeekAvailibilitySettings = async () => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_SCHEDULE_AVAILIBILITY +
        `?token=${token}&filtercompanyids=${params.id}`;

      const response = await getData(requestUrl);

      console.log("response in get all availibility settings", response);

      if (response.status) {
        setMessageType("success");
        if (response.data.length === 0) {
          createWeekAvailibilityHandler();
        } else {
          const sortedResponse = response.data.sort(
            (a, b) => a.weekdayorder - b.weekdayorder
          );
          setAvalibilityDays(sortedResponse);
        }
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsLoading(false);
      setShowAlert(true);
    }
  };

  //clear Time FromDay week settings
  const clearTimeFromDayHandler = async () => {
    const checkBoxes = document.querySelectorAll('input[name="daycheckbox"]');

    for (let checkBox of checkBoxes) {
      if (checkBox.checked) {
        const dataTimeIds = JSON.parse(checkBox.getAttribute("data-timeids"));

        console.log("dataTimeIds", dataTimeIds);

        if (dataTimeIds.length > 0) {
          for (let dataTimeId of dataTimeIds) {
            if (dataTimeId._id) {
              try {
                let requestUrl =
                  url.API_BASE_URL +
                  url.API_DELETE_SCHEDULE_TIME_AVAILIBILITY +
                  `/${dataTimeId._id}?token=${token}`;

                const response = await deleteData(requestUrl);

                console.log("response in delete availibility", response);
              } catch (error) {
                console.log(error.message);
              }
            }
          }
          // uncheck the selected checkbox
          checkBox.checked = false;
        }
      }
    }
    getAllWeekAvailibilitySettings();
  };

  useEffect(() => {
    if (params.id) {
      const initializeData = async () => {
        await getCompanyDetails();
        await getAllWeekAvailibilitySettings();
        setIsDataReady(true);
      };
      initializeData();
    }
  }, [params.id]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  return (
    <div id="content_wrapper">
      <section className="event-details-wrapper bg-white pb-5">
        <TabsHeader
          commonHeaderObject={commonHeaderLinkLists(t)}
          activeOption="Health Centers"
        />
        {params.id && <HealthCenterCommonHeader moduleName="schedule" />}
        <div className="container-fluid px-lg-5 pt-4 pt-md-0">
          <CompanyScheduleHeader reloadList={getCompanyDetails} />

          {isLoading || !isDataReady ? (
            <LoadingSkeleton />
          ) : (
            <div className="bg-white p-4 rounded-10 shadow-sm border border-gray-300">
              <h3 className="fw-semibold mb-4">Create weekly Schedule</h3>

              <div className="d-flex align-items-center justify-content-between mb-3">
                <p className="fw-semibold mb-0">
                  {t("Select days of week and hours")}
                </p>
                <Link
                  to="#"
                  className="d-flex align-items-center gap-1 fw-semibold text-danger text-decoration-none"
                  onClick={clearTimeFromDayHandler}
                >
                  <span className="d-block material-symbols-outlined fs-lg">
                    delete
                  </span>
                  <span className="d-block">{t("Clear")}</span>
                </Link>
              </div>

              {/* List of days availability */}
              <ul className="d-flex flex-column gap-2 list-unstyled">
                {avalibilityDays.map((dayData, index) => (
                  <li
                    className="d-flex align-items-center gap-3 bg-light p-3 rounded"
                    key={index}
                  >
                    <div className="form-check d-flex align-items-center gap-2 p-0 m-0">
                      <input
                        className="form-check-input border-2 border-gray-400 m-0 shadow-none"
                        type="checkbox"
                        id={dayData.slug}
                        name="daycheckbox"
                        value={dayData._id}
                        data-timeids={JSON.stringify(
                          dayData.timeavailibilitylist
                        )}
                      />
                      <label
                        className="form-check-label fw-semibold"
                        htmlFor={dayData.slug}
                      >
                        {dayData.dayname.substring(0, 3).toUpperCase()}
                      </label>
                    </div>

                    <div className="flex-fill">
                      {dayData.timeavailibilityids.length === 0 ? (
                        <p className="text-muted mb-0">{t("Closed")}</p>
                      ) : (
                        <div className="d-flex flex-column gap-2">
                          {dayData.timeavailibilitylist.map(
                            (timeData, index) => (
                              <ul
                                className="times lh-1 d-flex align-items-center gap-2 flex-wrap list-unstyled mb-0"
                                key={index}
                              >
                                <li className="px-2 py-1 text-gray border border-gray-300 rounded-pill">
                                  {timeData.starttime}
                                </li>
                                <li className="text-gray">-</li>
                                <li className="px-2 py-1 text-gray border border-gray-300 rounded-pill">
                                  {timeData.endtime}
                                </li>
                                <li
                                  className={
                                    timeData?.location === ""
                                      ? "d-none"
                                      : "text-gray"
                                  }
                                >
                                  -
                                </li>
                                <li
                                  className={
                                    timeData?.location === ""
                                      ? "d-none"
                                      : "px-2 py-1 text-gray border border-gray-300 rounded-pill"
                                  }
                                >
                                  {timeData?.location}
                                </li>
                                <li
                                  className={
                                    timeData?.companyname === ""
                                      ? "d-none"
                                      : "text-gray"
                                  }
                                >
                                  -
                                </li>
                                <li
                                  className={
                                    timeData?.companyname === ""
                                      ? "d-none"
                                      : "px-2 py-1 text-gray border border-gray-300 rounded-pill"
                                  }
                                >
                                  {timeData?.companyname}
                                </li>
                              </ul>
                            )
                          )}
                        </div>
                      )}
                    </div>

                    <Link
                      to="#"
                      className="text-muted ms-auto"
                      data-bs-toggle="modal"
                      data-bs-target="#editTimeForDay"
                      onClick={() => setselectedDayId(dayData._id)}
                    >
                      <span className="d-block material-symbols-outlined">
                        {dayData.timeavailibilitylist.length === 0
                          ? "add"
                          : "edit"}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <SaveTimeModal
          afterModalClose={getAllWeekAvailibilitySettings}
          selectedDayId={selectedDayId}
          setselectedDayId={setselectedDayId}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </section>
    </div>
  );
};

export default HealthCenterScheduleBody;
